import { configureStore } from '@reduxjs/toolkit';
import videoQuizzesReducer from '../features/video-quiz/videoQuizzesSlice';

export default configureStore({
  reducer: {
    videoQuizzes: videoQuizzesReducer,
  },
});
